import { Country } from '@commenda/prisma';
import { GetNexusReturnType, NexusRule } from '../nexus/nexus.types';

export interface IPhysicalExposure {
  employee: {
    count: number;
  };

  location: {
    office: {
      count: number;
    };
  };
}

export interface IEconomicExposure {
  transactions: {
    total: number;
    volume: number; // number of total transactions
  };
}

export interface IExposureCorporation {
  id: number;
  corporationDisplayName: string;

  incorporationJurisdictionState: string; // ISO 3166-2A state codes
  incorporationJurisdictionStateName: string;

  incorporationCountry: Country;

  physical: IPhysicalExposure | null;
  economic: IEconomicExposure | null;

  types: IExposureType[];
}

export enum IExposureType {
  PhysicalExposure = 'PhysicalExposure',
  EconomicExposure = 'EconomicExposure',
  EntityExposure = 'EntityExposure',
}

export interface IExposureState {
  code: string; // ISO 3166-2 Alpha code
  corporations: IExposureCorporation[];

  physical: IPhysicalExposure | null;
  economic: (IEconomicExposure & { threshold: NexusRule }) | null;
  nexus: Omit<GetNexusReturnType, 'state'> | null;
  types: IExposureType[];
}

export interface IExposureMap {
  exposures: {
    countries: {
      code: Country; // ISO 3166 Country Codes

      states: IExposureState[];

      corporations: IExposureCorporation[];

      physical: IPhysicalExposure | null;
      economic: IEconomicExposure | null;
      types: IExposureType[];
    }[];

    physical: IPhysicalExposure | null;
    economic: IEconomicExposure | null;
  };
}
